import { useAuthFakeStore, useAuthStore } from '@/store/pinia/index.js'

export default [
    {
        path: '/',
        name: 'home',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/chat/index'),
        beforeResolve(routeTo, routeFrom, next) {
            if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") { 
                const authStore = useAuthStore()
                const isUserLoggedIn = authStore.loggedIn

                if (isUserLoggedIn) {
                    next({
                        name: 'home'
                    })
                } else {
                    next()
                }
            }
            else {
                const fakeAuth = useAuthFakeStore()
                const isUserLoggedIn = fakeAuth.loggedIn
                if (isUserLoggedIn) {
                    next({
                        name: 'home'
                    })
                } else {
                    next({
                        name: "login"
                    })
                }

            }
        },
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/pages/account/login.vue'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {

                if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
                    const authStore = useAuthStore()
                    const isUserLoggedIn = authStore.loggedIn

                    if (isUserLoggedIn) {
                        next({
                            name: 'home'
                        })
                    } else {
                        next()
                    }

                } else {
                    const fakeAuth = useAuthFakeStore()
                    const isUserLoggedIn = fakeAuth.loggedIn
                    // If the user is already logged in
                    if (isUserLoggedIn) {
                        next({
                            name: 'home'
                        })
                    } else {
                        next()
                    }

                }

            },
        },
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../views/pages/account/register.vue'),
    },
    {
        path: '/forgot-password',
        name: 'Forgot-password',
        component: () => import('../views/pages/account/forgot-password.vue'),
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
                    const authStore = useAuthStore()
                    authStore.logOut()
                    next({
                        name: 'login'
                    })
                } else {
                    const fakeAuth = useAuthFakeStore()
                    fakeAuth.logout()
                    next()

                }
            },
        },
    },
    {
        path: '/lock-screen',
        name: 'lock-screen',
        component: () => import('../views/pages/account/lock-screen'),
    }
]